import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Button } from '../ui/Shared';
export const Hero = () => {
  return <section className="md:pt-20 px-5 text-center relative overflow-hidden pt-[40px] pb-[40px]" data-id="element-114">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[80%] h-[70%] bg-cyan/5 rounded-full blur-[100px] -z-10 pointer-events-none" data-id="element-115"></div>

      <div className="max-w-[860px] mx-auto" data-id="element-116">
        <p className="text-xs tracking-[0.12em] uppercase text-cyan mb-4 md:mb-5 font-semibold" data-id="element-117">
          Sistema N°1 para profesores de italiano en Argentina
        </p>

        <h1 className="text-[clamp(34px,6vw,62px)] font-extrabold leading-[1.1] tracking-tight mb-6 md:mb-7" data-id="element-118">
          Tu año de clases de
          <br data-id="element-119" />
          <span className="text-cyan" data-id="element-120">italiano resuelto</span>
        </h1>

        {/* Promise — promesa de la landing */}

        {/* Product image — 70% scale */}
        <div className="relative my-5 md:my-6 max-w-[450px] mx-auto" data-id="element-121">
          <div className="absolute inset-0 bg-cyan/10 blur-[60px] rounded-full -z-10" data-id="element-122"></div>
          <img src="https://cdn.magicpatterns.com/uploads/2bMevAueBthwyyET4XUpFk/c4d79fad-ff75-4157-9d9e-42643b80b0a6.png" alt="KIT ITALIANO PRO — caja del producto con módulos, bonos y materiales" width="900" height="600" loading="eager" decoding="async" fetchPriority="high" className="w-full h-auto drop-shadow-[0_20px_40px_rgba(0,229,255,0.15)]" data-id="element-123" />
        </div>

        {/* Subtitle — subtitulo del modulo inicial */}
        <p className="text-[clamp(16px,2.3vw,19px)] text-[#aaa] max-w-[560px] mx-auto mb-6 leading-relaxed" data-id="element-124">
          El sistema completo para preparar alumnos de ciudadanía, CILS y CELI —
          con método, materiales e ingresos reales.
        </p>

        <div className="flex justify-center flex-wrap gap-5 mb-9" data-id="element-125">
          {['PDF Digital — Acceso Inmediato', 'Todos los niveles de experiencia', 'Descarga y aplica mañana mismo'].map((text, i) => <span key={i} className="text-[13px] text-gris-claro flex items-center gap-1.5" data-id="element-126">
              <CheckIcon size={16} className="text-verde stroke-[3]" data-id="element-127" /> {text}
            </span>)}
        </div>

        <Button href="#ofertas" className="w-full md:w-auto" data-id="element-128">
          💥 Quiero mi Kit Italiano Pro ahora
        </Button>

        <p className="text-xs text-gris-claro mt-4" data-id="element-129">
          Garantía 7 días · Pago seguro · Mercado Pago
        </p>

        <div className="flex flex-wrap justify-center gap-x-9 gap-y-6 mt-12" data-id="element-130">
          {[{
          num: '+500',
          label: 'Profesores'
        }, {
          num: '4.9',
          label: 'Rating'
        }, {
          num: '+570',
          label: 'Páginas'
        }, {
          num: '36',
          label: 'Herramientas listas'
        }].map((stat, i) => <div key={i} className="text-center" data-id="element-131">
              <div className="text-[38px] font-extrabold text-cyan leading-none" data-id="element-132">
                {stat.num}
              </div>
              <div className="text-[13px] text-gris-claro mt-1" data-id="element-133">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};